// extracted by mini-css-extract-plugin
module.exports = {"actionsTop":"UserEntitlements_actionsTop__1AYD5","actionsBottom":"UserEntitlements_actionsBottom__2l8tv"};